import TabbedSilo from "@/components/TabbedSilo";

export default function RealEstate() {
  return (
    <TabbedSilo
      eyebrow="Portfolio · Real Estate"
      title="Real Estate"
      subtitle="Rentals, an owner-financed note, and held properties — managed and unmanaged."
      assetType="real_estate"
      mode="real_estate"
    />
  );
}
